// FILE: src/store/websockets/ws.ts

import { wsStore, wsGlobalConfig } from "@bigswiss-gmbh/fast-ws";
// Removed circular import of store
import { getAccessToken } from "../services/tokenManager";
import { chatRoute, identityRoute, paymentsRoute } from "./ws-routes";

// 1) Create a global config without store
const globalCfg: wsGlobalConfig = {
  basewsUrl: "/ws",
  defaultAutoReconnect: true,
  defaultReconnectDelayMs: 5000,
  token: () => getAccessToken() ?? undefined,
  // store removed here
};

// 2) Instantiate the wsStore
export const dcdWs = new wsStore(globalCfg);

/**
 * Kick each active route so it reconnects with the latest token.
 */
export const reconnectActiveRoutes = () => {
  const routeMap = (dcdWs as any)?.routeMap as Map<string, { ws: WebSocket | null }> | undefined;
  if (!routeMap) return;
  for (const [routeName, routeState] of routeMap.entries()) {
    if (routeState?.ws) {
      dcdWs.connectRoute(routeName);
    }
  }
};

// 3) Registered WebSocket routes
dcdWs.registerRoute(paymentsRoute,    { name: "payments",       prefix: "/payments", });
dcdWs.registerRoute(chatRoute,        { name: "chat",           prefix: "/chat", });
dcdWs.registerRoute(identityRoute,    { name: "identity",       prefix: "/identity", });

// ------------------------------------------------------------------------
// DEBUG: log every inbound WS payload (routeName + raw payload)
// ------------------------------------------------------------------------
if ((dcdWs as any)?.onMessage) {
  // fastWsRedux ≥2.1 exposes onMessage(routeName, payload)
  (dcdWs as any).onMessage((route: string, data: unknown) => {
    console.log(`[WS][${route}]`, data);
  });
} else if ((dcdWs as any)?.subscribe) {
  // fallback for older API: subscribe returns { route, data }
  (dcdWs as any).subscribe((evt: any) => {
    console.log(`[WS][${evt.route}]`, evt.data);
  });
}
